import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import { getProgramWeeksDataByProgramId } from 'src/modules/programs/selectors/programsSelectors';
import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/emotional-wb-home@3x.png';
import { color, font } from 'src/shared/styles/variables';

import { CPProgramWeek } from '../../models/cpProgram';

const StepHeading = styled(S.StepHeading)({
    maxWidth: '30.63rem',
});

const AreaDescription = styled('div')({
    marginBottom: '1.75rem',
});

const AreaHeading = styled('h4')(
    {
        color: color.blueLagoon,
        textTransform: 'capitalize',
    },
    font.heavy(font.size.medium),
);

interface StateProps {
    weeks: CPProgramWeek[];
}

interface Props extends StateProps {
    programId: ProgramEnum;
}

export const EndOfCourseStepContainer: React.SFC<Props> = ({ weeks }) => {
    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading small>Wrap Up</S.StepHeading>
                    <StepHeading>Congrats on finishing the Core Pillars Program!</StepHeading>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.ContentColumn md={14}>
                    {weeks.map(week => (
                        <AreaDescription key={week.weekNumber}>
                            <AreaHeading>
                                {week.readableWeekNumber}. {week.title}
                            </AreaHeading>
                            <S.StepDescription small>
                                {week.endOfCourseDefinition || week.definition}
                            </S.StepDescription>
                        </AreaDescription>
                    ))}
                    <S.StepDescription small>
                        Come back to the program anytime to do these exercises again or for a
                        refresher.
                    </S.StepDescription>
                </S.ContentColumn>
                <S.ContentColumn md={10}>
                    <S.StepIcon iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
        </>
    );
};

const mapStateToProps = (state: AppState, ownProps: Props): StateProps => ({
    weeks: getProgramWeeksDataByProgramId(state, ownProps.programId) as CPProgramWeek[],
});

export const EndOfCourseStep = connect(mapStateToProps)(EndOfCourseStepContainer);
